import { useState } from "react";
import { Download } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";

export function LogExport({ kind }) {
  const [before, setBefore] = useState(() => { const d = new Date(); d.setMonth(d.getMonth() - 6); return d.toISOString().slice(0, 10); });
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try {
      const res = await api.get(`/admin/logs/export?kind=${kind}&before=${before}`, { responseType: "blob" });
      const n = res.headers["x-row-count"];
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a"); a.href = url; a.download = `${kind}-log-before-${before}.csv`; a.click(); URL.revokeObjectURL(url);
      toast.success(`Exported ${n ?? ""} ${kind} row${n === "1" ? "" : "s"} older than ${before}. Nothing was deleted.`);
    } catch { toast.error("Export failed"); }
    finally { setBusy(false); }
  };
  return (
    <div className="flex items-center gap-2 flex-wrap" data-testid={`log-export-${kind}`}>
      <span className="text-[10px] tracking-widest uppercase opacity-60">Archive older than</span>
      <input type="date" value={before} onChange={e => setBefore(e.target.value)} className="bg-transparent border border-border rounded px-2 py-1 text-xs outline-none focus:border-[#83B68B]" data-testid={`log-export-${kind}-date`} />
      <button type="button" disabled={busy || !before} onClick={run} className="text-[10px] tracking-widest uppercase px-3 py-1.5 border border-border hover:border-[#83B68B] hover:text-[#83B68B] rounded inline-flex items-center gap-1.5 disabled:opacity-40" data-testid={`log-export-${kind}-btn`}>
        <Download className="w-3 h-3" /> {busy ? "Exporting…" : "Download CSV"}
      </button>
    </div>
  );
}
